import PropTypes from 'prop-types';
import { Popover, MenuItem, IconButton } from '@mui/material';
import Iconify from '../../../components/iconify';

// ----------------------------------------------------------------------

export default function ActionsPopover({ open, onClose, onEditClick, onDeleteClick }) {
  return (
    <Popover
      open={Boolean(open)}
      anchorEl={open}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{
        sx: { width: 160 },
      }}
    >
      <MenuItem onClick={onEditClick}>
        <Iconify icon="eva:edit-fill" sx={{ mr: 2 }} />
        Edit
      </MenuItem>

      <MenuItem onClick={onDeleteClick} sx={{ color: 'error.main' }}>
        <Iconify icon="eva:trash-2-outline" sx={{ mr: 2 }} />
        Delete
      </MenuItem>
    </Popover>
  );
}

ActionsPopover.propTypes = {
  open: PropTypes.node,
  onClose: PropTypes.func,
  onEditClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
};
